<span class="status-bubble {{ statusClass }}">{{ statusName }}</span>